import React, { FC } from 'react';

import { Container, Column, Row } from '../../../../grid/Grid';
import { MaterialIcon } from '../../../../material-icon/MaterialIcon';

import styles from './modal_full_screen_header.module.scss';

type Props = {
  onClose: () => void;
  'data-test-id'?: string;
};

export const ModalFullScreenHeader: FC<Props> = ({
  children,
  onClose,
  ...props
}) => {
  return (
    <div className={styles.container}>
      <Container className={styles.content}>
        <Row className={styles.row}>
          <Column medium={5}>
            <div
              onClick={onClose}
              className={styles.link}
              data-test-id={props['data-test-id']}
            >
              <span className={styles.icon}>
                <MaterialIcon name="arrow_back" />
              </span>
              <p className={styles.title}>{children}</p>
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  );
};
